export class SearchFilter {
    searchName
    filterType = 'search'
    constructor(searchName) {
        this.searchName = searchName
    }

    apply(products) {
        if (this.searchName === '') {
            return products
        }
        return products.filter(product => {
            return (product.Descripcion.toLowerCase().indexOf(this.searchName.toLowerCase()) > -1)
        })
    }
}